import { Component, inject, input, Input, OnInit, signal, WritableSignal } from '@angular/core';

import { PinMapIcon } from '../../icons/pin-map/pin-map';
import { CalendarioIcon } from '../../icons/calendario/calendario';
import { EdificioIcon } from '../../icons/edificio/edificio';
import { RelojIcon } from '../../icons/reloj/reloj';
import { TurnoAsignado } from '../../models/Turno.model';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Multimedia } from '../multimedia/multimedia';
import { MultimediaService, PlaylistItem } from '../../services/api/multimedia.service';

@Component({
  selector: 'app-turno-actual',
  imports: [CommonModule, Multimedia, EdificioIcon, RouterLink],
  templateUrl: './turno-actual.html',
  styleUrl: './turno-actual.scss'
})
export class TurnoActual implements OnInit {
  private multimediaService = inject(MultimediaService);

  @Input() turno!: TurnoAsignado | null;
  @Input() turno2!: TurnoAsignado | null;
  @Input() turno3!: TurnoAsignado | null;
  @Input() sala: string | null = null;
  @Input() municipio: string = 'Municipio de Durango';
  @Input() unidad: string = 'Unidad Administrativa Central';
  multimedia1 = input<PlaylistItem | null>();
  multimedia2 = input<PlaylistItem | null>();

  hora = signal(new Date());

  async ngOnInit(): Promise<void> {
    setInterval(() => {
      this.hora.set(new Date());
    }, 1000);
  }

  get turnoActual(): TurnoAsignado {
    if (!this.turno) {
      return {
        id: '',
        tramite: '',
        claveTurno: '',
        puesto: ''
      };
    }
    return this.turno;
  }

 get segundoturno(): TurnoAsignado {
    if (!this.turno2) {
      return {
        id: '',
        tramite: '',
        claveTurno: '',
        puesto: ''
      };
    }

    return this.turno2;
  }

  get tercerTurno(): TurnoAsignado {
    if (!this.turno3) {
      return {
        id: '',
        tramite: '',
        claveTurno: '',
        puesto: ''
      };
    }

    return this.turno3;
  }

  get claveTurno(): string {
    return this.turnoActual.claveTurno;
  }

  get claveTurno2(): string {
    return this.segundoturno.claveTurno;
  }

  get claveTurno3(): string {
    return this.tercerTurno.claveTurno;
  }
}
